import * as z from "zod";
import i18n from "i18next";
import { en, fi } from "zod/locales";

switch (i18n.language) {
	case "fi":
		z.config(fi());
		break;
	default:
		z.config(en());
		break;
}
